import React, {useEffect} from 'react';
import {ProfileMenu} from "../../components/ProfileMenu/ProfileMenu";
import {useDispatch, useSelector} from "react-redux";
import {cleareForwadingPath, logout} from "../../redux/reducers/login-reducer";
import {getProfile, loadProfileData} from "../../redux/reducers/user-profile-reducer";
import { cleanHashinfo } from '../../redux/reducers/act-reducer';

export const ProfileMenuContainer = () => {
    const {user, loading} = useSelector(getProfile)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(loadProfileData)
    }, [])

    const logOut = () => {
        dispatch(cleanHashinfo())
        dispatch(cleareForwadingPath())
        dispatch(logout())
    }

    return <ProfileMenu firstName={user?.first_name} onLogOutButtonClick={logOut} loading={loading}/>
}